import { ALL_VALUE, IFilterOptionProps } from "./types";

export const normalizeValue = (value: string | string[] | null): string[] | null => {
    if (!value) {
        return null;
    }

    if (Array.isArray(value)) {
        return value;
    }

    return [value];
};

export const normalizeOptions = <TQuery extends string>(
    labelPrefix: string | undefined,
    options: string[] | IFilterOptionProps<TQuery>[],
    multiSelect: boolean
): IFilterOptionProps<TQuery>[] => {
    const result: IFilterOptionProps<TQuery>[] = options.map<IFilterOptionProps<TQuery>>(
        (option: string | IFilterOptionProps<TQuery>) => {
            const { value, label, nestedFilters }: IFilterOptionProps<TQuery> =
                typeof option === "string" ? { value: option, label: option } : option;

            return {
                label: typeof label === "string" ? (labelPrefix ? `${labelPrefix}.${label}` : label) : label,
                value,
                nestedFilters
            };
        }
    );
    if (multiSelect) {
        result.unshift({ label: labelPrefix ? `${labelPrefix}.all` : "All", value: ALL_VALUE, isAll: true });
    }
    return result;
};
